mutation saveContent($input: SaveContentInput!) {
  saveContent: saveContent(input: $input) {
    id
  }
}
